<template>
  <v-container>
    <v-card>
      <v-card-text class='bg-blue-lighten-3'>
        QR code {{qr_code}} is not currently assigned.
      </v-card-text>
      <v-card-text
          v-show='listChoice && (chosenProducer || chosenStockage)'
          @click='clearFilterChoice'
          class='clickable bg-blue-lighten-4'
          >
          {{listChoice == 'p' ? 'Producer' : 'Stockage'}}: {{chosenProducer?.display_name}} {{chosenStockage?.name}}. Click to change
      </v-card-text>
    </v-card>

    <v-card v-show='listChoice == null'>
      <v-card-subtitle>Où on êtes-vous dans votre projet?</v-card-subtitle>
      <v-card-actions>
        <v-btn @click="choose('p')">éolienne (producteur)</v-btn>
        <v-btn @click="choose('st')">stockage</v-btn>
      </v-card-actions>
    </v-card>

    <v-card v-show="listChoice == 'p' && chosenProducer == null">
      <ProducerForm
          @updateProducer='selectProducer'
          />
    </v-card>

    <v-card v-show="listChoice == 'st' && chosenStockage == null">
      <StockageSelect
          @updateStockage='selectStockage'
          />
    </v-card>
    <v-card v-show='(chosenProducer || chosenStockage) && (!chosenUnit && !newTrackedPart)'>
      <UnitsList
          :producer_id='chosenProducer? chosenProducer.pk : null'
          :stockage_id='chosenStockage? chosenStockage.pk : null'
          @unitSelected='selectUnit'
          />
      <v-card-actions>
        <v-btn
            @click="createNewUnit"
            >
            Ma pièce n'est pas dans la liste ci-dessus
        </v-btn>
      </v-card-actions>
    </v-card>
      <v-card v-show="newTrackedPart">
        <StockPartSelect
            :onlyUnits=true
            />
        <UnitForm
            :askPlace="chosenStockage? true : false"
            :stockageId=chosenStockage?.pk
            :askStockage=false
            :askStockPart=false
            />
        <v-btn
            class='bg-blue-lighten-4 align-right'
            @click="save"
          >SAVE</v-btn>
      </v-card>

    <v-card v-show="chosenUnit">
      <StockPartInfo/>

      <UnitForm
          :askPlace="chosenStockage? true : false"
          :stockageId=chosenStockage?.pk
          :askStockage=false
          :askStockPart=false
          :editNdS=false
          />
      <v-card-actions class="justify-end">
        <v-btn
            class='bg-blue-lighten-4'
            @click="save"
            >
            SAVE
        </v-btn>
      </v-card-actions>

    </v-card>
  </v-container>
</template>

<script>
  import ProducerForm from "@/components/ProducerForm"
  import StockageSelect from "@/components/StockageSelect"
  import StockPartInfo from "@/components/StockPartInfo";
  import StockPartSelect from "@/components/StockPartSelect";
  import UnitsList from "@/components/UnitsList"
  import UnitForm from "@/components/UnitForm"

  export default {
    props: {
      qr_code: { type: String, required: true },
    },
    components: {
      ProducerForm,
      StockageSelect,
      StockPartInfo,
      StockPartSelect,
      UnitsList,
      UnitForm,
    },
    computed: {
      producerItems() {
        return this.$store.state.producers.items.map(p => ({ text: p.name, value: p }))
      },
      stockageItems() {
        return this.$store.state.stockages.items.map(s => ({ text: s.name, value: s }))
      },
      stock_part() {
        return this.chosenUnit?.stock_part ?? undefined
      }
    },
    methods: { 
      choose(val) {
        this.listChoice = val
      },
      selectProducer(item) {
        this.$store.dispatch('producers/updateEdit', item)
        this.chosenProducer = item
      },
      selectStockage(item) {
        this.$store.dispatch('places/getItems', {stockage_id: item.pk, size:-1})
        this.$store.dispatch('stockages/updateEdit', item)
        this.chosenStockage = item
      },
      clearFilterChoice(){
        this.listChoice = null;
        this.chosenProducer = null;
        this.$store.dispatch('producers/cleanupEdit')
        this.chosenStockage = null;
        this.$store.dispatch('stockages/cleanupEdit')
        this.chosenUnit = null;
        this.newTrackedPart = null;
        this.$store.dispatch('units/cleanupEdit')
      },
      selectUnit(item) {
        item.unit.qr_code = this.qr_code
        this.$store.dispatch('stock_parts/updateEdit', item.unit.stock_part)
        this.$store.dispatch('units/updateEdit', item.unit).then(()=> {
          this.chosenUnit = item.unit;
        })
      },
      createNewUnit(){
        this.newTrackedPart = true;
        this.$store.dispatch('units/updateEdit', {qr_code: this.qr_code})
      },
      save(){
        if (this.$store.state.units.edit.stock_part) {
          this.$store.state.units.edit.stock_part_id = this.$store.state.units.edit.stock_part.pk
        } else {
          this.$store.dispatch('snackbar/showWarning', 'need stockpart assigned')
          return
        }
        let action = 'addItem'
        if (this.$store.state.units.edit.pk) action = 'editItem'
        if (this.chosenProducer) this.$store.state.units.edit.producer_id = this.chosenProducer.pk

        this.$store.dispatch(`units/${action}`, this.$store.state.units.edit).then(()=>{

        this.$emit('unit_saved')
          })
      }
    },
    data() {
      return {
        listChoice: null,
        chosenProducer: null,
        chosenStockage: null,
        chosenUnit: null,
        newTrackedPart: false,
      }
    }
  }
</script>

<style>
.clickable {
  cursor: pointer;
  user-select: none;
}

</style>
